import { useState } from 'react';
import { dataGridPremiumColumns } from '../../utils/helper';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import dayjs from 'dayjs';

const ProjectTaskReportsTable = ({ selectedValues }) => {
  const [rowModesModel, setRowModesModel] = useState({});

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'nickName',
      headerName: 'Név',
      type: 'string',
      renderCell: (data) => {
        return data?.row.user.nickName;
      },
    },
    {
      field: 'startDate',
      type: 'date',
      headerName: 'Kezdő dátum',
      valueGetter: (_data, row) => {
        return new Date(row.startDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.startDate).format('YYYY.MM.DD HH:mm');
      },
    },
    {
      field: 'endDate',
      type: 'date',
      headerName: 'Befejező dátum',
      valueGetter: (_data, row) => {
        return new Date(row.endDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.endDate).format('YYYY.MM.DD HH:mm');
      },
    },
    {
      field: 'timeSpent',
      headerName: 'Ráfordítás',
      type: 'number',
    },
    {
      field: 'description',
      headerName: 'Megjegyzés',
      type: 'string',
    },
  ]);

  return (
    <div className="overflow-x-auto">
      <div className="align-middle">
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <DatagridPremiumUi
            datagridIdentifier={DataGridIdentifiers.ProjectTaskListReportsTable}
            height={400}
            columns={columns}
            rows={selectedValues?.taskListReport ?? []}
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            headerFilters={false}
            onCellDoubleClick={(_params, event) => {
              event.defaultMuiPrevented = true;
            }}
            slots={{
              toolbar: '',
            }}
            getRowHeight={() => 'auto'}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectTaskReportsTable;
